import { FC } from "react";

interface IReturnNumber {
    num: any;
}

export const ReturnNumber: FC<IReturnNumber> = ({ num }) => {
    const formattedNumber = new Intl.NumberFormat("ru", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    }).format(Number(num)).replace(",", ".");

    const finalValue = formattedNumber.endsWith(".0")
        ? formattedNumber.slice(0, -2)
        : formattedNumber;

    return <>{finalValue}</>;
};
